import { __decorate, __metadata } from "tslib";
import NeoModel from '../../Model/NeoModel';
import { Observable } from '../../Model/Decorators';
var ProgressState = /** @class */ (function () {
    function ProgressState() {
        this._progress = 0;
        /** Animation state used by UI components. */
        this.hasAnimated = false;
        this.timeUp = this.timeUp.bind(this);
    }
    Object.defineProperty(ProgressState.prototype, "progress", {
        /** Gets the current progress % */
        get: function () {
            return this._progress;
        },
        /** Sets the current progress %. Stops the auto increment timer. */
        set: function (value) {
            this._progress = Math.max(0, Math.min(value, 1));
            this.stop();
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Resume the auto increment timer.
     * @param progress Progress to start from.
     * @param halfLife Time in seconds for the progress to reach half way.
     */
    ProgressState.prototype.resume = function (progress, halfLife) {
        if (halfLife === void 0) { halfLife = 1; }
        if (progress !== undefined) {
            this._progress = progress;
        }
        ;
        var increment = 0.125 / halfLife;
        this.currentIncrement = increment * (1 - this.progress);
        this.slowPoint = 1 - ((1 - this.progress) * 0.5);
        this.hasAnimated = this.progress > 0;
        setTimeout(this.timeUp, 0);
        if (this.timer)
            clearInterval(this.timer);
        this.timer = setInterval(this.timeUp, 250);
    };
    /** Stop the auto increment timer. */
    ProgressState.prototype.stop = function () {
        clearInterval(this.timer);
    };
    ProgressState.prototype.timeUp = function () {
        if (this.progress >= this.slowPoint) {
            if (this.progress >= 0.97) {
                // Stop at 97%
                this.currentIncrement = 0;
                this.stop();
            }
            else if (this.currentIncrement > 0.001) {
                // Keep slowing down every tick when above the slow point.
                this.currentIncrement /= 1.33;
            }
        }
        this._progress += this.currentIncrement;
    };
    __decorate([
        Observable(),
        __metadata("design:type", Object)
    ], ProgressState.prototype, "_progress", void 0);
    ProgressState = __decorate([
        NeoModel,
        __metadata("design:paramtypes", [])
    ], ProgressState);
    return ProgressState;
}());
export { ProgressState };
